import { Box, List, Stack, Typography } from '@mui/material'
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { t } from 'i18next'
import React from 'react'
import { useColors } from '../hooks/useColors';
import colors from '../theme/colors';
import CalificacionA from '../images/capitan.svg'
import CalificacionB from '../images/navegante-estelar.svg'
import CalificacionC from '../images/navegante-digital.svg'
import CalificacionD from '../images/explorador.svg'

export function Leyenda() {

    const { getCalificationColor } = useColors()

    return (
        <List
            sx={{ maxWidth: 360, padding: 0, fontWeight: "normal" }}
            aria-label="Leyenda Etapas"
        >
            <ListItem disablePadding>
                <ListItemText primary={
                    <>
                        <Typography variant="h3" color={colors.parrafos} fontWeight={"bold"} paddingBottom={1}>
                            {t("cuestion.tituloLeyenda")}
                        </Typography>

                        <Stack flexDirection={'row'} alignContent={'center'} alignItems={'center'}>
                            <Box component={'img'} width={'24px'} height={'24px'} src={CalificacionA} alt="A" />
                            <Typography
                                variant='parrafo'
                                fontWeight={"bold"}
                                color={
                                    getCalificationColor(t("cuestion.LeyendaEtapaA"))
                                }>
                                &nbsp;- {t("cuestion.ResultadoLeyendaTextoA")}
                            </Typography>
                        </Stack>

                        <Stack flexDirection={'row'} alignContent={'center'} alignItems={'center'}>
                            <Box component={'img'} width={'24px'} height={'24px'} src={CalificacionB} alt="B" />
                            <Typography
                                variant='parrafo'
                                fontWeight={"bold"}
                                color={
                                    getCalificationColor(t("cuestion.LeyendaEtapaB"))
                                }>
                                &nbsp;- {t("cuestion.ResultadoLeyendaTextoB")}
                            </Typography>
                        </Stack>

                        <Stack flexDirection={'row'} alignContent={'center'} alignItems={'center'}>
                            <Box component={'img'} width={'24px'} height={'24px'} src={CalificacionC} alt="C" />
                            <Typography
                                variant='parrafo'
                                fontWeight={"bold"}
                                color={
                                    getCalificationColor(t("cuestion.LeyendaEtapaC"))
                                }>
                                &nbsp;- {t("cuestion.ResultadoLeyendaTextoC")}
                            </Typography>
                        </Stack>

                        <Stack flexDirection={'row'} alignContent={'center'} alignItems={'center'}>
                            <Box component={'img'} width={'24px'} height={'24px'} src={CalificacionD} alt="D" />
                            <Typography
                                variant='parrafo'
                                fontWeight={"bold"}
                                color={
                                    getCalificationColor(t("cuestion.LeyendaEtapaD"))
                                }>
                                &nbsp;- {t("cuestion.ResultadoLeyendaTextoD")}
                            </Typography>
                        </Stack>
                    </>
                } />
            </ListItem>
        </List>
    )
}
